<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Video:</label>
        <div class="input-group">
          <input type="text" placeholder="Video" v-model="editVideo" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <button class="submit primary" @click="onButtonClick">
          Edit Video
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["propsData"],
  data() {
    return {
      editVideo: null,
    };
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData: function () {
      this.editVideo = this.propsData;
    },
    onButtonClick: function () {
      this.$emit("onButtonClick", this.editVideo);
    },
  },
};
</script>
